<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 商户管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
                <el-input v-model="query.company_name" placeholder="公司名称" class="handle-input mr10"></el-input>
                <el-input v-model="query.number" placeholder="账号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary"  @click="handleSearch('distribute')" v-if="user_login_auth">微信零服务费</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="addVisible = true" style="float:right">添加
                </el-button>
                 <el-button type="primary" icon="el-icon-upload2" @click="exportVisible = true" style="float:right">导出表格
                </el-button>
         
            </div>
            <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
                @selection-change="handleSelectionChange" v-loading="loading">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="company_name" label="公司名称"></el-table-column>
                <el-table-column prop="company_account" label="账号"></el-table-column>
                <el-table-column prop="company_password" label="密码"></el-table-column>
                <el-table-column prop="company_mid" label="商户号"></el-table-column>
                <el-table-column prop="distribute" label="服务费（%）">
                    <template slot-scope="scope">
                        <span>微信:{{scope.row.distribute}} 支付宝:{{scope.row.trade_distribute}}
                            云闪付:{{scope.row.acp_distribute}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="one" label="主服务商"></el-table-column>
                <el-table-column prop="two" label="次服务商"></el-table-column>
                <el-table-column prop="time" label="时间"></el-table-column>

                <!-- <el-table-column label="账户余额">
                    <template slot-scope="scope">￥{{scope.row.money}}</template>
                </el-table-column> -->
                <!-- <el-table-column label="头像(查看大图)" align="center">
                    <template slot-scope="scope">
                        <el-image
                            class="table-td-thumb"
                            :src="scope.row.thumb"
                            :preview-src-list="[scope.row.thumb]"
                        ></el-image>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="date" label="注册时间"></el-table-column> -->
                <el-table-column label="操作" width="500" align="center">
                    <template slot-scope="scope">
                        <el-button @click="goMerchant(scope.$index, scope.row)">管理</el-button>
                        <el-button type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button type="warning" icon="el-icon-s-grid" @click="openQrcode(scope.$index, scope.row)">
                            商户二维码</el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                        <el-button type="success" icon="el-icon-bell" @click="voiceBroadcast(scope.$index,scope.row)">
                            语音播报
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.query"
                    :page-size="query.limit" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <!-- 添加弹出框 -->
        <el-dialog title="添加商户" :visible.sync="addVisible" width="500px">
            <el-form label-width="100px" :model="form" ref="form" :rules="rules">
                <el-form-item label="公司名称:" prop="company_name">
                    <el-input class="w400" v-model="form.company_name"></el-input>
                </el-form-item>
                <el-form-item label="账号:" prop="company_account">
                    <el-input class="w400" v-model="form.company_account"></el-input>
                </el-form-item>
                <el-form-item label="密码:" prop="company_password">
                    <el-input class="w400" v-model="form.company_password"></el-input>
                </el-form-item>
                <el-form-item label="商户号:" prop="company_mid">
                    <el-input class="w400" v-model="form.company_mid"></el-input>
                </el-form-item>

                <el-form-item label="微信服务费(%):" prop="distribute">
                    <el-input class="w400" v-model="form.distribute"></el-input>
                </el-form-item>
                <el-form-item label="支付宝服务费(%):" prop="acp_distribute">
                    <el-input class="w400" v-model="form.trade_distribute"></el-input>
                </el-form-item>
                <el-form-item label="云闪付服务费(%):" prop="acp_distribute">
                    <el-input class="w400" v-model="form.acp_distribute"></el-input>
                </el-form-item>
                <el-form-item label="主/次服务商:" prop="one">
                    <el-input class="w400" v-model="form.one" placeholder="若无服务商可为空"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="addMerchant()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑商户" :visible.sync="editVisible" width="500px">
            <el-form label-width="100px" :model="editform" ref="editform" :rules="rules">
                <el-form-item label="公司名称:" prop="company_name">
                    <el-input class="w400" v-model="editform.company_name"></el-input>
                </el-form-item>
                <el-form-item label="账号:" prop="company_account">
                    <el-input class="w400" v-model="editform.company_account"></el-input>
                </el-form-item>
                <el-form-item label="密码:" prop="company_password">
                    <el-input class="w400" v-model="editform.company_password"></el-input>
                </el-form-item>
                <el-form-item label="商户号:" prop="company_mid">
                    <el-input class="w400" v-model="editform.company_mid"></el-input>
                </el-form-item>
                <el-form-item label="微信服务费(%):" prop="distribute">
                    <el-input class="w400" v-model="editform.distribute"></el-input>
                </el-form-item>
                <el-form-item label="支付宝服务费(%):" prop="trade_distribute">
                    <el-input class="w400" v-model="editform.trade_distribute"></el-input>
                </el-form-item>
                <el-form-item label="云闪付服务费(%):" prop="acp_distribute">
                    <el-input class="w400" v-model="editform.acp_distribute"></el-input>
                </el-form-item>
                <!-- v-if="editform.two == null || editform.two == undefined || editform.two == '' " -->
                <el-form-item label="主/次服务商:" prop="one">
                    <el-input class="w400" v-model="editform.one" placeholder="若无服务商可为空"></el-input>
                </el-form-item>
                <!-- <el-form-item label="主/次服务商:" prop="two" v-else>
                    <el-input class="w400" v-model="editform.two" placeholder="若无服务商可为空"></el-input>
                </el-form-item>
                 -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="upMerchant()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="商户二维码" :visible.sync="qrcodeVisible" @close="closeCode" width="440px">
            <!-- 20220312 -->
            <div class="qrcode-content">
                <div ref="wecharqr">
                    <div class="wechar">
                        <div id="qrcode" ref="qrCodeUrl"></div>
                        <span>商户名称:{{qrcodeMname}}</span>
                    </div>
                </div>
                <div ref="wecharqrBig" style="position:fixed;top:-99999px">
                    <div class="wechar2">
                        <img src="@/assets/img/wechat.jpg" />
                        <div id="qrcode2" ref="qrcode2"></div>
                        <span>商户名称:{{qrcodeMname}}</span>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="qrcodeVisible = false">取 消</el-button>
                <el-button type="primary" @click="downLoad">下 载</el-button>
            </span>
        </el-dialog>

        <!-- 语音播报弹出框 -->
        <el-dialog :visible.sync="voiceVisible" width="500">
            <template slot="title">
                <span class="titleSpan">语音播报</span>
                <el-radio v-model="radio" label="1">老版本</el-radio>
                <el-radio v-model="radio" label="2">新版本</el-radio>
            </template>
            <div v-show="radio=='1'">
                <el-form :model="voicefrom" ref="voiceform" label-width="80px" :rules="rules111">
                    <el-form-item label="sn号" prop="sn">
                        <el-input class="w400" v-model="voicefrom.sn"></el-input>
                    </el-form-item>
                    <el-form-item label="token" prop="token">
                        <el-input class="w400" v-model="voicefrom.token"></el-input>
                    </el-form-item>
                    <el-form-item label="version" prop="version">
                        <el-input class="w400" v-model.number="voicefrom.version"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-bottom">
                    <el-button @click="voiceVisible = false">取 消</el-button>
                    <el-button type="primary" @click="voicePreservation()">保存</el-button>
                </div>
            </div>
            <div v-show="radio=='2'">
                <div class="addBut">
                    <el-button class="mr30" circle type="primary" icon="el-icon-plus" @click="addEquipment()">
                    </el-button>
                    <el-popover placement="top" width="150" v-model="popoverVisible">
                        <p>确定要移除吗？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="popoverVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="removeEquipment()">确定</el-button>
                        </div>
                        <el-button slot="reference" circle type="primary" icon="el-icon-minus"></el-button>
                    </el-popover>
                </div>
                <el-form ref="newvoiceformref" :model="newvoiceform" label-width="100px" :rules="rules2">
                    <!-- prop="equipmentId"   -->
                    <el-form-item v-for="(item,index) in newvoiceform.x_sn" :key="index" :label="'设备编号'+index" prop="x_sn">
                        <el-input class="w400" v-model="newvoiceform.x_sn[index]"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-bottom">
                    <el-button @click="voiceVisible = false">取 消</el-button>
                    <el-button type="primary" @click="newversionInfo()">保存</el-button>
                </div>
            </div>
        </el-dialog>
 <!-- 编辑弹出框 -->
    <el-dialog
      title="导出表格"
      :visible.sync="exportVisible"
      width="600px"
      @close="closeCode"
    >
      <el-form label-width="80px">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="value2"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
       
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" @click="getList" v-loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'
    import html2canvas from 'html2canvas'
    import {
        fetchData
    } from '../../api/index';
    const validateMoney = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入'))
        } else if (value.indexOf(".") != -1 && value.split('.').length > 2) {
            callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
        } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 2) {
            callback(new Error('请输入正确的小数位数')) //小数点后两位
        } else {
            callback();
        }
    };
    export default {
        name: 'basetable',
        data() {
            return {
                dowloadList:[],
                value2:'',
                btnLoading: false,
                 user_login_auth: 0,
                addLoading: false,
                addVisible: false,
                qrcodeVisible: false,
                popoverVisible: false,
                exportVisible:false,
                loading: true,
                query: {
                    id: '',
                    auth: '1',
                    limit: 8,
                    page: 1,
                    company_name: '',
                    number: ''
                },
                tableData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                pageTotal: 0,
                form: {
                    company_name: '',
                    company_account: '',
                    company_password: '',
                    company_mid: '',
                    distribute: '',
                    auth: 2,
                    one: ''
                },
                editform: {
                    one: '',
                    two: ''
                },
                idx: -1,
                id: -1,
                rules: {
                    company_name: [{
                        required: true,
                        message: '请输入商户名称',
                        trigger: 'change'
                    }, ],
                    company_account: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    }, ],
                    company_password: [{
                            required: true,
                            message: '请输入密码',
                            trigger: 'change'
                        },
                        {
                            min: 6,
                            max: 18,
                            message: '长度在 6 到 18 个字符',
                            trigger: 'blur'
                        }
                    ],
                    company_mid: [{
                        required: true,
                        message: '请输入商户号',
                        trigger: 'blur'
                    }, ],
                    distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    trade_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    acp_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    one: {
                        type: 'string',
                        // required:true,
                        trigger: 'blur'
                    }
                },
                voiceVisible: false, //控制语音播报是否显示
                voicefrom: {}, //保存语音播报的input
                rules111: { //验证规则
                    sn: [{
                        message: '请输入sn号，必须是数字',
                        required: true,
                    }],
                    token: [{
                        type: 'string',
                        message: '请输入token',
                        required: true,
                    }],
                    version: [{
                        type: 'number',
                        message: '请输入version，必须是数字',
                        required: true,
                    }],
                },
                rules2: {
                    x_sn: [{
                        message: '请输入设备编号',
                        required: true,
                        trigger: 'blur'
                    }]
                },
                qrcodeMname: '',
                newvoiceform: {
                    id: null,
                    sn: [],
                    type: '2'
                },
                // newSnLength: null, 用于控制不然其删除到
                radio: '1'
            };
        },
        created() {
            this.getData()
              this.user_login_auth = sessionStorage.getItem("user_login_auth");
        },
        activated() {
            this.getData()
        },
        methods: {
             getList(a) {
      console.log(a);
      if (!this.btnLoading) {
        this.btnLoading = true;
        let that = this;
        let url = that.$apiUrl.merchant.getMerchant
        let query = {
          id: sessionStorage.getItem("merchants_id")||'',
          start_time: "",
          end_time: "",
          auth: "",
          limit: 10000,
          page: 1,
          company_name: "",
        };
        query.auth = query.id == "" ? "1" : "2";
        if (that.value2) {
          query.start_time = that.value2[0];
          query.end_time = that.value2[1];
        } else {
          query.start_time = "";
          query.end_time = "";
        }
        console.log(query);

        that
          .$post(url, that.$params(query))
          .then((res) => {
            if (res.data.code == 200) {
              that.dowloadList = res.data.data.list;
              this.epexortExcel();
            }
          })
          .catch((error) => {
            this.$message.error(error);
            that.btnLoading = false;
          });
      }
    },
              epexortExcel() {
      const { export_json_to_excel } = require("../../api/Export2Excel.js");
      const tHeader = [
        "编号",
        "公司名称",
        "账号",
        "商户号",
        "微信服务费",
        "支付宝服务费",
        "云闪付服务费",
        "主服务商",
        "次服务商",
        "创建时间",
      ];
      // 上面设置Excel的表格第一行的标题
      const filterVal = [
        "id",
        "company_name",
        "company_account",
        "company_mid",
        "distribute",
        'trade_distribute',
        'acp_distribute',
        "one",
        "two",
        "time",
      ];
      // 上面的index、nickName、name是tableData里对象的属性
      const list = this.dowloadList; //把data里的tableData存到list
      const data = this.formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, "商户信息表");
      this.btnLoading = false;
    },
     formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
            reset() {
                this.$set(this.query, 'page', 1);
                this.query.company_name = '';
                this.query.number = '';
                this.getData()
            },
            // 获取 easy-mock 的模拟数据
            getData() {
                let that = this
                let url = that.$apiUrl.merchant.getMerchant
                that.$post(url, that.$params(that.query)).then(res => {
                    if (res.data.code == 200) {
                        that.loading = false
                        that.pageTotal = res.data.data.count
                        delete res.data.data.count;
                        res.data.data.list.forEach((item, index) => {
                            if (item.one == 'null') {
                                item.one = ''
                            }
                            if (item.two == 'null') {
                                item.two = ''
                            }
                        });
                        that.tableData = res.data.data.list
                    }
                }).catch(error => {
                    that.loading = false
                    this.$message.error(error)
                })
            },
            closeCode() {
                this.$refs.qrCodeUrl.innerHTML = ''
                this.exportVisible=false
            },
            // 触发搜索按钮
            handleSearch(val) {
                this.$set(this.query, 'page', 1);
                if(val=='distribute'){
                    this.query.distribute='1'
                }else{
                    this.query.distribute=''
                }
                console.log(this.query)
                this.getData();
                
               
            },
            goMerchant(index, row) {
                window.open('https://ym.huayetech.cn/#/dashboard?id=' + row.id + '&mid=' + row.company_mid)
            },
            // 删除操作
            handleDelete(index, row) {
                let that = this
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    })
                    .then(() => {
                        let url = that.$apiUrl.merchant.dleMerchant
                        let query = {
                            id: row.id
                        }
                        that.$post(url, that.$params(query)).then(res => {
                            console.log(res)
                            if (res.data.code == 200) {
                                that.getData()
                                that.$message.success("删除成功")
                            }
                        }).catch(error => {
                            this.$message.error(error)
                        })
                    })
                    .catch(() => {});
            },
            openQrcode(index, row) {
                let that = this
                this.qrcodeVisible = true
                this.qrcodeMname = row.company_name
                setTimeout(() => {
                    that.creatQrCode(row.id)
                }, 1);

            },
            creatQrCode(params) {
                document.getElementById("qrcode2").innerHTML = "";

                console.log(this.$refs.qrCodeUrl);
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: 'https://ym.huayetech.cn/index.php/page#/?id=' + params,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                });
                var qrcode2 = new QRCode(this.$refs.qrcode2, {
                    text: 'https://ym.huayetech.cn/index.php/page#/?id=' + params,
                    width: 1500,
                    height: 1500,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                });
                console.log(params);
                // this.qrcodeimg=qrcode;
                // this.qrcodeimg=aaaa;
            },
            downLoad() {
                let a = document.createElement('a');
                html2canvas(this.$refs.wecharqrBig, {
                    // scale:2,//扩大防止字体模糊
                    dpi: 350,
                }).then(canvas => {
                    a.href = canvas.toDataURL('image/png', 1.0);
                    a.download = '二维码';
                    a.click();
                })
                this.$message({
                    message: "正在进行下载保存",
                    type: 'success'
                })
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },
            addMerchant() {
                let that = this
                if (!that.addLoading) {
                    that.$refs['form'].validate((valid) => {
                        if (valid) {
                            that.addLoading = !that.addLoading
                            let url = that.$apiUrl.merchant.addMerchant
                            that.$post(url, that.$params(that.form)).then(res => {
                                that.addLoading = false
                                if (res.data.msg == "添加失败" || res.data.msg == '服务商错误' || res.data.msg ==
                                    "添加失败" || res.data.msg == "服务费错误" || res.data.msg == '服务商重复') {
                                    this.$message.error(res.data.msg)
                                } else if (res.data.msg == "添加成功") {
                                    that.$refs['form'].resetFields()
                                    that.addVisible = false
                                    that.getData()
                                    this.$message.success("添加成功")
                                }
                            }).catch(error => {
                                that.addLoading = false
                                this.$message.error(error)
                            })
                        }
                    })
                }

            },
            upMerchant() {
                let that = this
                that.$refs['editform'].validate((valid) => {
                    if (valid) {
                        console.log(that.editform)
                        let url = that.$apiUrl.merchant.upMerchant;
                        if (that.editform.one == null) {
                            that.editform.one = '';
                        }
                        if (that.editform.two == null) {
                            that.editform.two = '';
                        }
                        delete that.editform.sn;
                        delete that.editform.token;
                        delete that.editform.version;
                        delete that.editform.two;

                        that.$post(url, that.$params(that.editform)).then(res => {
                            if (res.data.msg == "修改失败" || res.data.msg == '服务商错误' || res.data.msg ==
                                '服务费设置错误' || res.data.msg == "添加失败" || res.data.msg == "服务费错误" || res
                                .data.msg == '必须有上级' || res.data.msg == '服务商重复') {
                                this.$message.error(res.data.msg)
                            } else if (res.data.msg == "修改成功") {
                                that.editVisible = false
                                that.getData()
                                this.$message.success("修改成功")
                            }
                        }).catch(error => {
                            this.$message.error(error)
                        })
                    }
                })
            },
            // 编辑操作
            handleEdit(index, row) {
                // 只能一个one字段，如果有two就显示two，没有就显示one
                this.idx = index;
                let editValue = Object.assign({}, row)
                if (editValue.two != null && editValue.two != undefined && editValue.two != '' && editValue.two !=
                    'null') {
                    editValue.one = editValue.two
                }
                this.editform = Object.assign({}, editValue);
                this.editVisible = true;
            },
            // 保存编辑
            saveEdit() {
                this.editVisible = false;
                this.$message.success(`修改第 ${this.idx + 1} 行成功`);
                this.$set(this.tableData, this.idx, this.form);
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'page', val);
                this.getData();
            },
            // 点击语音播报按钮，将值赋给新对象
            voiceBroadcast(index, row) {
                this.voicefrom = Object.assign({}, row);
                if (this.voicefrom.sn == 'null') {
                    this.voicefrom.sn = ''
                } else if (this.voicefrom.token == 'null') {
                    this.voicefrom.token = ''
                } else if (this.voicefrom.version == 'null') {
                    this.voicefrom.version = ''
                }

                let newvoiceform2 = Object.assign({}, row);
                newvoiceform2.x_sn = JSON.parse(newvoiceform2.x_sn);
                this.newvoiceform = newvoiceform2;
                if (this.newvoiceform.x_sn == null) {
                    this.newvoiceform.x_sn = []
                }
                
                this.voiceVisible = true;
            },
            // 语音播报保存
            voicePreservation() {
                this.$refs['voiceform'].validate((valid) => {
                    if (valid) {
                        let url = this.$apiUrl.merchant.voicechant
                        this.voicefrom.type = '1'; //type为1就是老版本
                        delete this.voicefrom.x_sn;
                        this.$post(url, this.$params(this.voicefrom)).then(res => {
                            if (res.data.msg == "修改失败") {
                                this.$message.error("修改失败")
                            } else if (res.data.msg == "修改成功") {
                                this.voiceVisible = false
                                this.getData()
                                this.$message.success("修改成功")
                            }
                        }).catch(error => {
                            this.$message.error(error)
                        })
                    }
                })
            },
            //添加和移除多个设备
            addEquipment() {
                this.newvoiceform.x_sn.push(null)
            },
            removeEquipment() {
                this.newvoiceform.x_sn.pop();
                this.popoverVisible = false;
            },
            //新版本设备保存按钮回调
            newversionInfo() {
                let verification = true;
                let newvoiceform2 = Object.assign({}, this.newvoiceform);
                for (let item of newvoiceform2.x_sn) {
                    if (item == null || item == undefined || item == '') {
                        verification = false;
                    }
                }

                if (verification) {
                    let url = this.$apiUrl.merchant.voicechant;
                    newvoiceform2.type = '2'; //type为2就是新版本
                    newvoiceform2.x_sn = JSON.stringify(newvoiceform2.x_sn);
                    delete newvoiceform2.sn
                    this.$post(url, this.$params(newvoiceform2)).then(res => {
                        console.log(res);
                        if (res.data.code == 200) {
                            this.$message.success("修改成功")
                            this.voiceVisible =false
                            this.getData()
                        } else {
                            this.$message.error("修改失败")
                        }
                    }).catch(error => {
                        this.$message.error(error)
                    })
                } else {
                    console.log('设备不能为空');
                    this.$message({
                        showClose: true,
                        message: '设备不能为空',
                        type: 'warning'
                    })
                }
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 180px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .wechar {
        width: 400px;
        height: 559px;
        background: url(../../assets/img/wechat.jpg) no-repeat center;
        background-size: 100%;
        z-index: -1000;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .wechar span {
        margin-top: 20px;
        font-size: 18px;
        font-weight: 450;
        color: #000;
    }

    .wechar2 {
        width: 3150px;
        height: 4402px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
    }

    .wechar2 img {
        display: block;
        width: 3150px;
        height: 4402px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
    }

    .wechar2 div {
        display: block;
        z-index: 1000;
    }

    /* .aaaaa div img{
        width:1500px;
    } */

    .wechar2 span {
        /* display:block; */
        margin-top: 100px;
        font-size: 130px;
        z-index: 1000;
        color: #000;
        font-weight: 450;
    }

    .titleSpan {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
        margin-right: 50px;
    }

    .addBut {
        position: absolute;
        top: 20px;
        right: 60px;
    }

    .dialog-bottom {
        display: flex;
        justify-content: right;
    }

    .mr30 {
        margin-right: 10px;
    }
</style>